import * as Yup from 'yup';

export interface IImpressaoComunicacaoVenda {
	numeroFicha: string;
	anoFicha: string;
}

export const initialValues: IImpressaoComunicacaoVenda = {
	numeroFicha: '',
	anoFicha: '',
};

export const schema = Yup.object<IImpressaoComunicacaoVenda>().shape({
	numeroFicha: Yup.string().required(`Campo Obrigatório: Número da Ficha.`),
	anoFicha: Yup.string().required(`Campo Obrigatório: Ano da Ficha Cadastral.`),
});
